//dependencias
import React, { Component } from 'react';

//componentes
import AlumnosMaestro from './alumnosMaestro'

class Index extends Component {

    render(){
        return(
            <div>
                <AlumnosMaestro />
            </div>
        );
    }

}
export default Index;